import { Tooltip } from "@material-ui/core";
import React from "react";

const MAX_LENGTH = 50;

export type TruncatedTextProps = Readonly<{
  text: string | null | undefined;
  maxLength?: number;
}>;

function TruncatedText({ text, maxLength = MAX_LENGTH }: TruncatedTextProps) {
  if (!text || text.length <= maxLength) {
    return <>{text}</>;
  }

  const truncated = `${text.substring(0, maxLength)}...`;

  return (
    <Tooltip title={text} placement="top">
      <span>{truncated}</span>
    </Tooltip>
  );
}

export default TruncatedText;
